<template>
  <div class="work-cover fixed left right top bottom" @contextmenu.prevent :style="{ visibility: showcover, }"
    v-if="showimages && showimages.length > 0">
    <div class="work-cover-top flex-lr">
      <div class="white-font font-size16 flex-lr" style="width: 80%;">
        <div class="font-more" style="max-width: calc(100% - 330px);">
          {{ showimages[showindex].name || '' }}
          <span style="padding-left: 30px;">{{ (showimages[showindex].exif.size / M).toFixed(2) }}M</span>

        </div>
        <attr2xc ref="attr2xc" @event="attr2xcEvent" v-if="draftinfo.activityId" :activityId="draftinfo.activityId"
          :selectids="selectids"></attr2xc>
      </div>
      <div class="flex-rr">
        <a class="download-icon" v-if="showimages[showindex].exif.type == 3" @click.stop="downloadFile">
          <img src="https://assets.pfotoo.com/icon/pc%E4%B8%8B%E8%BD%BD.svg" />
          <div class="white-font font-size14 flex-cm down-load-hover">复制</div>
        </a>
        <el-dropdown :hide-on-click="false" @command="downloadFile" v-else="">
          <span class="el-dropdown-link">
            <img src="https://assets.pfotoo.com/icon/pc%E4%B8%8B%E8%BD%BD.svg" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="compress">下载压缩文件</el-dropdown-item>
            <el-dropdown-item command="b">下载原文件</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <img src="https://assets.pfotoo.com/icon/pc%E5%85%B3%E9%97%AD.svg" style="margin-left:30px;" @click="close" />
      </div>
    </div>
    <div id="swiper" class="swiper-container">
      <div class="swiper-wrapper pppp">
        <div class="swiper-slide flex-cm" v-for="(item, index) in showimages" :key="index"
          :style="{ left: showindex == index ? 0 : (item.left || '100%'), }">
          <template v-if="item.exif.type == 1">
            <div class="swiper-bg" @click="showImgViewer(item,index)" :style="{ background: 'url(' + item.comurl + ') center center / contain no-repeat' }">
              <el-image-viewer v-if="imgViewerVisible[index]" :on-close="closeImgViewer" :url-list="[item.comurl]" />
              <div class="img-tips">点击图片进入大图预览</div>
            </div>
          </template>
          <template v-else-if="item.exif.type == 2">
            <!--
                        <video controls="controls" class="flex-cm" ref="video" style="max-height: calc(100vh - 80px);"
                               :id="'video'+index" :poster="item.comurl"
                               :src="item.playerUrl.replace('http://','//')" :preload="index==showindex ? true : false">
                        </video>
                        -->
            <VideoPlayer :src="item.playerUrl.replace('http://', '//')" ref="video"
              :id="'video-player-' + item.submissionId + '-' + index" :poster="item.comurl.replace('http://', '//')" />

          </template>
          <template v-else-if="item.exif.type == 3">
            <div class="swiper-bg flex-vc work-font-cover">
              <div class="work-font-content white-font font-size18">{{ item.exif.text }}</div>
            </div>
          </template>
          <template v-else-if="item.exif.type == 4">
            <div class="swiper-bg flex-vc bg-gray">
              <img :src="item.comurl" style="width: 120px;height: 120px;margin-bottom: 20px;" />
              <div class="black-font font-size20 font-more font-bold"
                style="width: 90%;text-align: center;opacity: .8;margin: 0 auto;">{{ item.exif.name }}
              </div>
            </div>
          </template>
          <template v-else-if="item.exif.type == 5">
            <div class="swiper-bg swiper-bg-audio">
              <div class="proview-audio-bg" :style="{ 'background-image': 'url(' + item.comurl + ')' }"></div>
              <audio controls ref="audio" style="margin-top: 60px;" class="audio-play">
                <source :src="item.playerUrl">
                您的浏览器不支持 audio 元素。
              </audio>
            </div>
          </template>
        </div>
      </div>
      <div class="swiper-button-prev swiper-button flex-cm" @click="previmage"
        :style="{ visibility: showindex > 0 && showcover != 'hidden' ? 'visible' : 'hidden' }">
        <img src="https://assets.pfotoo.com/icon/pc%E5%B7%A6%E7%AE%AD%E5%A4%B4.svg" />
      </div>
      <div class="swiper-button-next swiper-button flex-cm" @click="nextimage"
        :style="{ visibility: showindex < showimages.length - 1 && showcover != 'hidden' ? 'visible' : 'hidden' }">
        <img src="https://assets.pfotoo.com/icon/pc%E5%8F%B3%E7%AE%AD%E5%A4%B4.svg" />
      </div>
      <div style="position: absolute;bottom: 0px;left: calc(50% - 131px);">
        <el-button-group>
          <el-button @click="prevSubmissionClick" :disabled="!previewSubmissionData" type="primary"
            icon="el-icon-arrow-left">上一个投稿</el-button>
          <el-button @click="nextSubmissionClick" :disabled="!nextSubmission" type="primary">下一个投稿<i
              class="el-icon-arrow-right el-icon--right"></i></el-button>
        </el-button-group>
      </div>

    </div>
    <dialogDown ref="proviewDialogDown" :draftinfo="draftinfo" :residueSize="draftinfo.residualDownloadTraffic / 1">
    </dialogDown>
  </div>
</template>
<script>
import App from '../../util/comfun'
import dialogDown from './down.vue'
import VideoPlayer from './videoPlayer.vue'
import attr2xc from './attr2xc.vue'
const M = 1024 * 1024
export default {
  props: {
    materialList: {//投稿文件资源列表
      type: Array,
      value: []
    },
    draftinfo: {
      type: Object,
      value: null
    },
    identityType: {
      type: Number,
      value: -1,
    },
  },
  components: {
    dialogDown,
    VideoPlayer,
    attr2xc,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      showcover: 'hidden',
      M: M,
      showimages: [],
      showindex: 0,
      selectids: [],
      nextSubmission: null,
      previewSubmissionData: null,
      imgViewerVisible: [],
    }
  },
  methods: {
    close() {
      console.log('this.$refs.video', this.$refs.video)
      this.stop()
      this.showcover = 'hidden';
      this.showindex = 0
      if (this.stuckFeedbackBox) {
        this.stuckFeedbackBox.close()
      }
      this.closeImgViewer()
    },
    stop() {
      if (this.$refs.video && this.$refs.video.length > 0) {
        this.$refs.video.forEach(video => {
          //video.dispose()
          video.pause()
        })
      }
      if (this.$refs.audio && this.$refs.audio.length > 0) {
        this.$refs.audio.forEach(audio => {
          audio.pause()
        })
      }
      
    },
    show(sub = null) {
      this.showindex = 0
      console.log('show.sub', sub, this.materialList)
      this.showcover = 'visible';
      let videoNumber = 0
      this.videoPlayNumber = []
      if (sub) {
        sub.materialList.forEach((image, ix) => {
          this.videoPlayNumber[ix] = ''
          if (image.coverInfo && typeof image.coverInfo == 'string') {
            image.coverInfo = JSON.parse(image.coverInfo)
          }
          if (typeof image.exif != 'object') {
            try { image.exif = JSON.parse(image.exif) } catch (e) { image.exif = {} }
          }
          console.log('show.image.exif', image.exif)
          if (image.exif && image.size && !image.exif.size) {
            image.exif.size = image.size
          }
          App.setPlayerUrl(image)
          switch (image.exif.type / 1) {
            case 1:
              if (Number(image.exif.size) > 20 * 1024 * 1024 && !image.hasTransed) {
                image.comurl = image.playerUrl;
              } else {
                image.comurl = image.playerUrl + '?imageMogr2/format/webp/thumbnail/750x/quality/100!/ignore-error/1';
              }
              break;
            case 2:
              this.videoPlayNumber[ix] = videoNumber++;
              image.comurl = image.url + '?vframe/jpg/offset/1/w/' + image.exif.width + '/h/' + image.exif.height;
              if(image.coverInfo && image.coverInfo.url){
                image.comurl = image.coverInfo.url;
              }
              break;
            case 3:
              image.comurl = '';
              break;
            case 4:
              image.comurl = 'https://qn002.pfotoo.com/file/' + image.exif.mark + '.svg';
              break;
            case 5://audio
              image.comurl = image.coverInfo.url + '?imageMogr2/thumbnail/100000@'
              break;
          }
          image.name = image.materialName
          image.submissionId = sub.submissionId
        })
        this.showimages = sub.materialList
        this.selectids = [sub.submissionId]
        console.log('this.selectids', this.selectids)
        this.autoPlay()
        this.queryNextSubmission()
        //this.showImgViewer()
      }
    },
    downloadFile(command) {
      console.log('downloadFile', this.showimages[this.showindex], this.showlist, this.draftinfo)
      if (this.showimages[this.showindex].exif.type == 3) {
        let createInput = document.createElement("input");
        createInput.value = this.showimages[this.showindex].exif.text;
        document.body.appendChild(createInput);
        createInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        createInput.style.display = "none";
        this.$message({ message: "复制成功", type: "success" });
        return
      }
      if (![0, 1].includes(this.identityType)) {
        return this.$message({
          showClose: true,
          message: App.identityTypes(this.identityType) + '无操作权限',
          type: 'error',
        });
      }
      if (this.draftinfo.residualDownloadTraffic / 1 < 1) {
        return this.$refs.proviewDialogDown.show({ size: 1, total: 1 })
      }
      let suffix = ''
        , url = this.showimages[this.showindex].url

      let fileName = this.showimages[this.showindex].name || this.showimages[this.showindex].id
      if (!/\.[a-z]{3,4}[34]?/i.test(fileName)) {
        if (this.showimages[this.showindex].exif.suffix) {
          suffix = '.' + this.showimages[this.showindex].exif.suffix
        } else {
          if (this.showimages[this.showindex].exif.type == 1) {
            suffix = '.jpg'
          }
          if (this.showimages[this.showindex].exif.type == 2) {
            suffix = '.mp4'
          }
        }
      }
      fileName += suffix
      if (command == 'compress' && this.showimages[this.showindex].exif.size < 20 * 1024 * 1024) {//压缩下载
        if (/(\.jpg)|(\.jpeg)|(\.png)|(\.bmp)|(\.gif)/g.test(fileName)) {
          url += '?imageMogr2/thumbnail/1220x/quality/100!/ignore-error/1'//缩略图
        }
      }
      let loading = this.$loading({
        lock: true,
        text: "正在下载 ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: 'custom-loading'
      });
      App.download(url, fileName).then((file) => {
        console.log('App.download', file)
        //扣费
        let fileSize = this.showimages[this.showindex].exif.size
        App.demand('/download/record/save', 'POST', {
          "activityId": this.draftinfo.activityId,
          "downloadTerminal": 1,
          "downloadType": 1,
          "fileName": file.name,
          "fileSize": file.size > fileSize ? fileSize : file.size,
          "status": 2
        })
        setTimeout(() => { loading.close(); }, 800)
      }).catch(() => {
        setTimeout(() => { loading.close(); }, 800)
      })
    },
    autoPlay() {
      setTimeout(() => {
        console.log(this.showindex, this.showimages[this.showindex])
        if (this.showimages[this.showindex].exif.type == 5) {
          if (this.$refs.audio && this.$refs.audio.length > 0) {
            this.$refs.audio.forEach(audio => {
              audio.src = this.showimages[this.showindex].url
              audio.play()
            })
          }
        } else {//视频
          if (this.showimages[this.showindex].exif.type == 2) {
            if (this.showimages[this.showindex].exif.hasSource == 1
              && (!this.showimages[this.showindex].transcodeMaterialList || this.showimages[this.showindex].transcodeMaterialList.length < 1)) {
              this.stuckFeedback()
            }
            //$('#video'+this.showindex)[0].play();
            let submissionId = this.showimages[this.showindex].submissionId
            console.log('this.$refs.video', this.showindex, this.$refs.video[this.showindex], this.$refs.video)
            //$('#video-player-'+submissionId+'-'+this.showindex)[0].play();
            let player = this.$refs.video[this.videoPlayNumber[this.showindex]]
            player.play()
          }
        }
      }, 800)

    },
    previmage() {
      if (this.showindex >= 1) {
        this.stop()
        this.showindex--;
        this.autoPlay()
        this.showimages[this.showindex].left = 0;
        this.showimages[this.showindex + 1].left = '100%';
      }
    },
    nextimage() {
      if (this.showindex < this.showimages.length - 1) {
        this.stop()
        this.showindex++;
        this.autoPlay()
        this.showimages[this.showindex].left = 0;
        this.showimages[this.showindex - 1].left = '-100%';
      }
    },
    setIndex(index = 0) {
      this.showindex = index
    },
    stuckFeedback() {
      if (this.stuckFeedbackBox) return;
      this.stuckFeedbackBox = this.$message({
        dangerouslyUseHTMLString: true,
        message: '<a href="https://openai.weixin.qq.com/webapp/jDgwDGsnHz8LXBmMwbNBffXZuPqmsS?robotName=Fotoo%E5%BE%81%E9%9B%86%E4%B8%80%E4%B8%8B" target="_blank"><div class="tap text-df text-black">加载中｜<span class="text-green">反馈卡顿 &gt;</span></div></a>',
        duration: 0,
        showClose: true,
        iconClass: '-',
        onClose: () => {
          this.stuckFeedbackBox = null
        }
      });
    },
    attr2xcEvent(data) {
      console.log('attr2xcEvent', data)
      //this.getnewlist()
    },
    queryNextSubmission() {
      let params=JSON.parse(JSON.stringify(window.SubmissionParams||{}))
      params.currentSubmissionId=this.selectids[0]
      if(params.pageSize) delete params.pageSize
      if(params.pageIndex) delete params.pageIndex
      App.demand('/submission/queryNextSubmission', 'POST', params).then((res) => {
        console.log('queryNextSubmission', res)
        this.nextSubmission = res.data.nextSubmission || null
        this.previewSubmissionData = res.data.previewSubmissionData || null
      })
    },
    nextSubmissionClick() {
      if (this.nextSubmission) {
        this.stop()
        this.show(this.nextSubmission)
      }
    },
    prevSubmissionClick() {
      if (this.previewSubmissionData) {
        this.stop()
        this.show(this.previewSubmissionData)
      }
    },
    showImgViewer(item,index) {
      this.imgViewerVisible = [];
      this.imgViewerVisible[index] = true;
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'hidden';
      document.addEventListener("touchmove", m, false); // 禁止页面滑动

    },
    closeImgViewer() {
      this.imgViewerVisible = [];
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'auto';
      document.removeEventListener("touchmove", m, true);
    },
  },
  mounted() {
    if (this.materialList && this.materialList.length > 0) {
      this.showimages = this.materialList
    }
  },

}
</script>

<style scoped lang="scss">
.work-cover {
  background: rgba(0, 0, 0, .8);
  z-index: 100;
}

.work-cover-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 60px;
  padding: 0 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #1a2e3b;
  z-index: 2;
}

.work-cover-top img {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.down-load-hover {
  width: 44px;
  height: 25px;
  position: absolute;
  top: 50px;
  left: -10px;
  border-radius: 4px;
  background: rgba(0, 0, 0, .6);
  display: none;
  text-align: center;
  line-height: 25px;
}

.download-icon:hover .down-load-hover {
  display: block;
}

.download-icon {
  display: block;
  position: relative;
}

.swiper-container {
  width: 94%;
  height: 100%;
  position: relative;
  margin: 0 auto;
}

.swiper-wrapper {
  position: absolute;
  left: 0;
  top: 60px;
  bottom: 0;
  width: 100%;
  overflow: hidden;
}

.swiper-slide {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: left .4s ease-in .1s;
  transition: left .4s ease-in .1s;
}

.swiper-bg {
  width: 90%;
  height: 96%;
}

.swiper-button {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  width: 40px;
  height: 100%;
  cursor: pointer;
}

.swiper-button-prev {
  left: 0;
}

.swiper-button-next {
  right: 0;
}

.swiper-button img {
  width: 25px;
}

.work-hide {
  padding: 0 5px;
  line-height: 20px;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, .5);
}

.work-font-cover {
  padding: 50px;
  box-sizing: border-box;
  white-space: pre-wrap;
  background: radial-gradient(circle, #1a2e3b, #353535);
  /* overflow-y: scroll; */
}

.swiper-bg-audio {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.proview-audio-bg {
  width: 200px;
  height: 200px;
  box-shadow: 0px 1px 4px 1px #9cc5ad;
  border-radius: 50%;
  background-size: cover;
}

.stuckFeedback {
  width: 400px;
  height: 40px;
  background: #FFFFFF;
  box-shadow: 0 0 1px 0 #d0cfcf80;
  border-radius: 4px;
  position: absolute;
  left: calc(50% - 200px);
  line-height: 40px;
  box-sizing: border-box;
  padding-left: 28px;
  padding-right: 18px;
}
.img-tips {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
}


</style>


// WEBPACK FOOTER //
// src/components/dialog/proview.vue